import type { SxProps, Theme } from '@mui/material'

export const sectionTitleSx: SxProps<Theme> = {
  fontSize: '0.75rem',
  fontWeight: 600,
  mb: 0.75,
  color: 'primary.main',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
}

export const fieldLabelSx: SxProps<Theme> = {
  fontSize: '0.65rem',
  display: 'block',
  mb: 0,
  color: 'text.secondary',
  fontWeight: 500,
}

export const fieldValueSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: '0.8rem',
  color: 'text.primary',
  lineHeight: 1.2,
}

export const compactFieldSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  py: 0.25,
  borderBottom: '1px solid',
  borderColor: 'divider',
  '&:last-child': {
    borderBottom: 'none',
  },
}

export const sectionDividerSx: SxProps<Theme> = {
  height: '1px',
  backgroundColor: 'divider',
  my: 2,
  mx: 0,
}

export const flexWrapContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1.5,
}

export const fileCardSx: SxProps<Theme> = {
  flex: '1 auto',
  borderRadius: 1.5,
  overflow: 'hidden',
  border: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'background.paper',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    borderColor: 'primary.main',
    boxShadow: 2,
    transform: 'translateY(-1px)',
  },
}

export const songCardSx: SxProps<Theme> = {
  minWidth: '220px',
  flex: '1 1 220px',
  p: 1.5,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1.5,
  backgroundColor: 'background.paper',
  transition: 'all 0.2s ease-in-out',
}

export const songTitleSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: '0.85rem',
  mb: 1,
  color: 'text.primary',
  lineHeight: 1.3,
}

export const songFieldSx: SxProps<Theme> = {
  fontSize: '0.75rem',
  color: 'text.secondary',
  mb: 0.5,
  display: 'block',
  lineHeight: 1.4,
}

export const componentCardSx: SxProps<Theme> = {
  p: 1.5,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1.5,
  backgroundColor: 'background.paper',
  mb: 1.5,
}

export const componentFieldLabelSx: SxProps<Theme> = {
  fontSize: '0.65rem',
  color: 'text.secondary',
  fontWeight: 500,
  mb: 0.25,
}

export const distributionDetailCardSx: SxProps<Theme> = {
  p: 1.5,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1.5,
  backgroundColor: 'background.paper',
  mb: 1,
}
